<template>
  <div class="p-2 prescription-content mb-2">
    <b-modal
      size="xl"
      no-close-on-backdrop
      hide-footer
      id="modalGetPrescriptionResident"
      title="MEDICAMENTOS DO RESIDENTE NA BOX QUE NÃO ESTÃO NO SISTEMACLIN"
    >
      <div>
        <b-overlay :show="loading" opacity="0.99">
          <div class="row">
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
              v-if="medicamento_ids.length > 0"
            >
              <label>SELECIONE A PRESCRIÇÃO</label>
              <div
                class="v-clean text-center p-2"
                v-if="group_prescription_medicines.length == 0"
              >
                RESIDENTE NÃO POSSUI PRESCRIÇÕES!
                <div class="row">
                  <div class="col-md-6">
                    <label>Data inicial da prescrição</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="group_prescription_medicine_start_date"
                    />
                  </div>
                  <div class="col-md-6">
                    <label>Data final da prescrição</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="group_prescription_medicine_end_date"
                    />
                  </div>
                </div>
              </div>
              <select
                v-if="group_prescription_medicines.length > 0"
                v-model="group_prescription_medicine_id"
                class="form-control"
              >
                <option value>SELECIONE...</option>
                <option
                  v-for="value in group_prescription_medicines"
                  :key="value.id"
                  :value="value.id"
                >
                  {{
                    `${formatDate(value.start_date, false)} - ${formatDate(
                      value.end_date,
                      false
                    )}`
                  }}
                </option>
              </select>
            </div>
            <div class="col-md-12 text-right" v-if="medicamento_ids.length > 0">
              <v-btn
                :disabled="medicamento_ids.length == 0"
                class="btn-modern btn-modern-save"
                @click="copyToPrescriptionSistemaClin"
              >
                <i class="fas fa-copy mr-2"></i>
                Copiar para prescrição selecionada
              </v-btn>
            </div>
          </div>
          <v-data-table
            :headers="headers"
            :items="medicines"
            disable-pagination
            hide-default-footer
            no-data-text="Nenhum medicamento encontrado na BOX"
          >
            <template v-slot:[`item.nome`]="{ item }">
              <v-checkbox
                :label="item.nome"
                v-model="medicamento_ids"
                :value="item.id"
              ></v-checkbox>
            </template>
          </v-data-table>
          <div class="mt-2 mb-2">
            <ErrorsMessages :errors="errors" />
          </div>
        </b-overlay>
      </div>
    </b-modal>

    <div class="text-right">
      <v-btn
        min-height="70"
        :disabled="loading"
        @click="getMedicinesNotPrescribedBySistemaClinByResidentId"
        class="btn-modern btn-modern-save text-center"
      >
        VERIFICAR MEDICAMENTO(S)
        <br />
        NA BOX QUE NÃO FORAM
        <br />
        ENVIADOS PELO SISTEMACLIN</v-btn
      >
      <!-- <v-btn @click="handleModal" class="btn-modern btn-modern-add"
        ><i class="fas fa-search mr-2 text-twenty"></i> VERIFICAR MEDICAMENTOS
        DO RESIDENTE NA BOX</v-btn
      > -->
    </div>

    <div class="p-2" v-if="executeMedicinesNotPrescribedBySistemaClin">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Princípio ativo</th>
            <th>Fabricante</th>
            <th>Observação</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              colspan="4"
              class="text-center"
              v-if="medicinesNotPrescribedBySistemaClin.length == 0 && !loading"
            >
              Nenhum medicamento encontrado!
            </td>
          </tr>
          <tr
            v-show="medicinesNotPrescribedBySistemaClin.length > 0 && !loading"
            v-for="(
              medicineNotPrescribedBySistemaClin, key
            ) in medicinesNotPrescribedBySistemaClin"
            :key="key"
          >
            <td>{{ medicineNotPrescribedBySistemaClin.nome }}</td>
            <td>{{ medicineNotPrescribedBySistemaClin.principio_ativo }}</td>
            <td>{{ medicineNotPrescribedBySistemaClin.fabricante }}</td>
            <td>
              {{
                medicineNotPrescribedBySistemaClin.observacao
                  ? medicineNotPrescribedBySistemaClin.observacao
                  : "--"
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

import api from "../../../services/api";

import { formatDate } from "../../../lib/format";

import toast from "../../../lib/ToastNotification";

export default {
  name: "Prescription",

  components: {
    ErrorsMessages,
  },

  props: {
    resident_id: [String, Number],
    box_id: [String, Number],
  },

  data() {
    return {
      exist_group_prescription_medicine: false,
      group_prescription_medicine_id: "",

      group_prescription_medicine_start_date: "",
      group_prescription_medicine_end_date: "",

      executeMedicinesNotPrescribedBySistemaClin: false,
      medicinesNotPrescribedBySistemaClin: [],

      medicines: [],

      group_prescription_medicines: [],

      medicamento_ids: [],

      headers: [
        { text: "Medicamento", value: "nome", sortable: false },
        { text: "Princípio ativo", value: "principio_ativo", sortable: false },
        { text: "Fabricante", value: "fabricante", sortable: false },
        { text: "Observações", value: "observacao", sortable: false },
      ],

      loading: false,
      errors: [],
    };
  },

  methods: {
    formatDate,

    async handleModal() {
      this.medicamento_ids = [];
      this.group_prescription_medicine_id = "";
      this.group_prescription_medicine_start_date = "";
      this.group_prescription_medicine_end_date = "";
      this.$bvModal.show("modalGetPrescriptionResident");
      await this.getPrescriptionResident();
      await this.handlePrescriptionsResident();
    },

    async getMedicinesNotPrescribedBySistemaClinByResidentId() {
      try {
        this.executeMedicinesNotPrescribedBySistemaClin = true;
        this.loading = true;

        let { resident_id, box_id } = this;

        let params = { resident_id, box_id };

        const response = await api.get(
          "/rest-home/box/resident/medicines/not/prescribed",
          {
            params,
          }
        );

        const { medicinesNotPrescribedBySistemaClin } = response.data;

        this.medicinesNotPrescribedBySistemaClin =
          medicinesNotPrescribedBySistemaClin;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async handlePrescriptionsResident() {
      try {
        let { resident_id } = this;

        let params = { resident_id };

        const response = await api.get(
          "/rest-home/resident/all-group-prescriptions-normal",
          {
            params,
          }
        );

        const { group_prescription_medicines } = response.data;

        this.group_prescription_medicines = group_prescription_medicines;

        if (group_prescription_medicines.length > 0) {
          this.exist_group_prescription_medicine = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getPrescriptionResident() {
      try {
        this.errors = [];

        this.loading = true;

        let { resident_id, box_id } = this;

        let params = { resident_id, box_id };

        let response = await api.post(
          "/rest-home/box/resident/prescription/medicines",
          params
        );

        let { error, message, medicines } = response.data;

        if (error) {
          this.errors = [message];
        } else {
          this.medicines = medicines;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async copyToPrescriptionSistemaClin() {
      try {
        this.loading = true;

        let {
          resident_id,
          group_prescription_medicine_id,
          exist_group_prescription_medicine,
          group_prescription_medicine_start_date,
          group_prescription_medicine_end_date,
          box_id,
          medicamento_ids,
          medicines,
        } = this;

        let medicamentos = [];
        for (let medicine of medicines) {
          if (medicamento_ids.includes(medicine.id)) {
            medicamentos.push(medicine);
          }
        }

        let params = {
          resident_id,
          group_prescription_medicine_id,
          exist_group_prescription_medicine,
          group_prescription_medicine_start_date,
          group_prescription_medicine_end_date,
          box_id,
          medicamentos,
        };

        const response = await api.post(
          "/rest-home/box/resident/medicines/copy",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$bvModal.hide("modalGetPrescriptionResident");
          this.$emit("success");
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>
